/**
 * 文档管理的语言、分类选项和公开预览地址
 */
import { getApiUrl } from '@/utils/env'
import type { MarkdownDocument } from '@/api/services/documents'

export const LANGUAGE_OPTIONS = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: 'English' }
]

export const CATEGORY_OPTIONS = [
  { value: 'docs', label: '文档' },
  { value: 'legal', label: '法律文档' },
  { value: 'help', label: '帮助中心' },
  { value: 'product_features', label: '产品功能说明' }
]

export function categoryLabel(category: string) {
  return CATEGORY_OPTIONS.find((option) => option.value === category)?.label ?? category
}

// 后端渲染的公开文档页（只返回已发布的文档）
export function documentPreviewUrl(document: Pick<MarkdownDocument, 'language' | 'slug' | 'category'>) {
  const path = `/${encodeURIComponent(document.language)}/docs/${encodeURIComponent(document.slug)}`
  return `${getApiUrl(path)}?category=${encodeURIComponent(document.category)}`
}

export const MAX_MARKDOWN_BYTES = 5 * 1024 * 1024
